module.exports = __webpack_public_path__ + "img/ArrowGreen.39235ce5.svg";